// Initialize and add the map
/* eslint-disable-next-line */
(function( $ ) {

    var acfMap = $( '.acf-map ' );

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

        var customColours   = $( acfMap ).data( 'custom-colours' );
        var landColour      = $( acfMap ).data( 'land-colour' );
        var waterColour     = $( acfMap ).data( 'water-colour' );

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {};

        if ( customColours ) {
            mapArgs = {
                zoom: $el.data('zoom') || 16,
                /* eslint-disable-next-line */
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": landColour,
                            },
                        ],
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [{"color": waterColour}, {"visibility": "on"}, {"weight": "0.01"}],
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": waterColour,
                            },
                            {
                                "visibility": "on",
                            },
                        ],
                    },
                ],
            };
        } else {
            mapArgs = {
                zoom: $el.data('zoom') || 16,
                /* eslint-disable-next-line */
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            };
        }
        /* eslint-disable-next-line */
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng ),
        };

        // Create marker instance.
        var icon = $( acfMap ).data( 'marker' );

        /* eslint-disable-next-line */
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            icon: icon,
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            /* eslint-disable-next-line */
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            // Show info window when marker is clicked.
            /* eslint-disable-next-line */
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    /* eslint-disable-next-line */
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map').each(function(){
        /* eslint-disable-next-line */
        var map = initMap( $(this) );
    });
});

})(jQuery);